import React from 'react';

export default function ProgressBar({ done, total, height = 8 }) {
  const safeTotal = total > 0 ? total : 1;
  const pct = Math.max(0, Math.min(100, Math.round((done / safeTotal) * 100)));
  const colour = pct === 100 ? '#10b981' : pct >= 60 ? '#ab63f2' : '#f59e0b';
  return (
    <div className="w-full bg-gray-200 rounded-full overflow-hidden" style={{ height }}>
      <div
        className="h-full rounded-full transition-all duration-300"
        style={{ width: `${pct}%`, background: colour }}
      />
    </div>
  );
}
